/**
 * Cross-cutting admin UI strings shared by System, GeoDataRevision, Elasticsearch.
 */

export const ADMIN_COMMON_MESSAGES = {
  de: {
    languageAria: 'Sprache',
    switchToEn: 'Zu Englisch wechseln',
    switchToDe: 'Zu Deutsch wechseln',
    kicker: 'Verwaltung',
    colName: 'Name',
    colValue: 'Wert',
    pleaseWait: 'Bitte warten…',
    close: 'Schließen',
    cancel: 'Abbrechen',
    apply: 'Anwenden',
    yes: 'Ja',
    no: 'Nein'
  },
  en: {
    languageAria: 'Language',
    switchToEn: 'Switch to English',
    switchToDe: 'Switch to German',
    kicker: 'Admin',
    colName: 'Name',
    colValue: 'Value',
    pleaseWait: 'Please wait…',
    close: 'Close',
    cancel: 'Cancel',
    apply: 'Apply',
    yes: 'Yes',
    no: 'No'
  }
}

/**
 * Look up a message key: page dictionary first, then shared admin commons.
 */
export function adminT (pageMessages, lang, key) {
  const page = pageMessages[lang] || pageMessages.de || {}
  const common = ADMIN_COMMON_MESSAGES[lang] || ADMIN_COMMON_MESSAGES.de
  return page[key] ?? pageMessages.de?.[key] ?? common[key] ?? ADMIN_COMMON_MESSAGES.de[key] ?? key
}
